import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const inp = "h-10 w-20 rounded-lg border border-[#D2E0D8] px-2 text-center text-sm font-bold";

const Row = ({ p, onSaved }) => {
  const [v, setV] = useState(p.personal ?? "");
  const save = async (val) => {
    try { await api.put(`/admin/targets/${p.staff_id}`, { daily: val === "" ? null : Number(val) }); toast.success(`Target saved for ${p.name}`); onSaved(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const pct = Math.min(100, Math.round((p.done / p.goal) * 100));
  return (
    <tr className="border-t border-[#E3E6DD]" data-testid={`target-row-${p.staff_id}`}>
      <td className="px-3 py-3"><b>{p.name}</b><div className="text-xs text-[#6B7F74]">{p.mobile}{p.online && " · online"}</div></td>
      <td className="px-3 py-3"><div className="flex items-center gap-2"><div className="h-2 w-24 overflow-hidden rounded-full bg-[#E7F6EE]"><div className="h-full bg-[#2E9E6B]" style={{ width: `${pct}%` }} /></div>
        <span className="text-sm font-bold" data-testid={`target-progress-${p.staff_id}`}>{p.done}/{p.goal}</span></div></td>
      <td className="px-3 py-3"><div className="flex items-center gap-2">
        <input type="number" min="1" max="50" value={v} placeholder="All" onChange={(e) => setV(e.target.value)} className={inp} data-testid={`target-input-${p.staff_id}`} />
        <button onClick={() => save(v)} className="rounded-lg bg-[#0D3B2B] px-3 py-2 text-xs font-bold text-white" data-testid={`target-save-${p.staff_id}`}>Save</button>
        {p.personal && <button onClick={() => { setV(""); save(""); }} className="text-xs font-semibold text-[#B4401F]" data-testid={`target-reset-${p.staff_id}`}>Use default</button>}
      </div></td>
    </tr>
  );
};

export const AdminTargets = () => {
  const [d, setD] = useState(null);
  const [g, setG] = useState("");
  const load = () => api.get("/admin/targets").then((r) => { setD(r.data); setG(String(r.data.daily)); });
  useEffect(() => { load(); }, []);
  const saveAll = async () => {
    try { await api.put("/admin/targets", { daily: Number(g) }); toast.success("Default target saved for all partners"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!d) return <p className="text-sm text-[#6B7F74]">Loading…</p>;
  const hit = d.partners.filter((p) => p.done >= p.goal).length;
  return (
    <div className="space-y-5" data-testid="admin-targets">
      <div className="flex flex-wrap items-end gap-4 rounded-2xl border border-[#E3E6DD] bg-white p-5">
        <div><p className="text-xs font-bold uppercase tracking-wider text-[#6B7F74]">Default daily target (all partners)</p>
          <div className="mt-2 flex items-center gap-2">
            <input type="number" min="1" max="50" value={g} onChange={(e) => setG(e.target.value)} className={`${inp} h-12 w-24 text-lg`} data-testid="target-global-input" />
            <span className="text-sm text-[#6B7F74]">pickups / day</span>
            <button onClick={saveAll} className="h-12 rounded-xl bg-[#2E9E6B] px-5 font-bold text-white" data-testid="target-global-save">Save for all</button>
          </div></div>
        <p className="ml-auto text-sm text-[#0D3B2B]" data-testid="target-summary"><b>{hit}</b> of {d.partners.length} partners reached today's target</p>
      </div>
      <p className="text-sm text-[#6B7F74]">Set a personal target to override the default for one partner. Leave it empty to use the default.</p>
      <div className="overflow-x-auto rounded-2xl border border-[#E3E6DD] bg-white">
        <table className="w-full text-left text-sm">
          <thead className="bg-[#F4F8F5] text-xs uppercase text-[#6B7F74]"><tr><th className="px-3 py-2">Partner</th><th className="px-3 py-2">Today</th><th className="px-3 py-2">Personal target</th></tr></thead>
          <tbody>{d.partners.map((p) => <Row key={p.staff_id} p={p} onSaved={load} />)}</tbody>
        </table>
      </div>
    </div>
  );
};
